
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "enable-background": "new 0 0 64 64",
    "id": "Layer_1",
    "version": "1.1",
    "viewBox": "0 0 64 64",
    "xml:space": "preserve",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "g",
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M60.7749138,24.1749058H36.1170769l22.9283447-6.9560547c1.0571289-0.3212891,1.6538086-1.437499,1.3334961-2.4941397   L56.8989372,3.2452188c-0.1538086-0.5078125-0.503418-0.9335938-0.9711914-1.1835938   c-0.4672852-0.25-1.015625-0.3046875-1.5234375-0.1503906L2.6445427,17.6104527   c-0.5078125,0.1542969-0.9335938,0.5039063-1.1835938,0.9716797s-0.3037109,1.0166016-0.1494141,1.5244141L4.801281,31.5870152   c0.262207,0.8623066,1.0551758,1.4189472,1.9125977,1.4189472c0.1923828,0,0.3876953-0.0283203,0.5810547-0.0869141   l15.7229614-4.7700825c0.085022,0.0110474,0.1689453,0.0259399,0.257019,0.0259399h35.5v30.0000019h-46v-21.5   c0-1.1044922-0.8955078-2-2-2s-2,0.8955078-2,2v23.5c0,1.1044922,0.8955078,2,2,2h50c1.1044922,0,2-0.8955078,2-2v-34   C62.7749138,25.0704136,61.879406,24.1749058,60.7749138,24.1749058z M8.0473747,28.5118198L5.7207146,20.857523   L53.6513786,6.3194375l0.3087769,1.0187378l-8.3175659,2.7722783c-1.0478516,0.3496094-1.6142578,1.4824219-1.2651367,2.5302734   c0.2792969,0.8378906,1.0595703,1.3681641,1.8969727,1.3681641c0.2099609,0,0.4233398-0.0332031,0.6328125-0.1035156   l8.213623-2.7376099l0.8498535,2.8040161L8.0473747,28.5118198z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M39.2749138,44.6749077c3.3085938,0,6-2.6914063,6-6v-3.1367188c0-1.1044922-0.8955078-2-2-2h-16   c-1.1044922,0-2,0.8955078-2,2v3.1367188c0,3.3085938,2.6914063,6,6,6H39.2749138z M29.2749138,38.6749077v-1.1367188h12v1.1367188   c0,1.1025391-0.8969727,2-2,2h-8C30.1718864,40.6749077,29.2749138,39.7774467,29.2749138,38.6749077z"
          }
        }
      ]
    }
  ]
})
    }
  